import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=5fc0aad7&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=ts"
export * from "./Fields.vue?vue&type=script&lang=ts"
import style0 from "./Fields.vue?vue&type=style&index=0&id=5fc0aad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0aad7",
  null
  
)

export default component.exports